import { renderRouteInPortal } from "./routePortal";
import { ReportExcelExportedPubSub } from "./pubsubs/PubSub";

/**
 * Obtiene los bytes del Excel de una ruta de reporte (`/user/reports/excel/...`)
 * sin descargarlo: monta la ruta en un portal oculto dentro de la app ya cargada
 * y espera a que `ReportPage` publique el libro ya armado.
 *
 * Es el equivalente de `renderRouteToHtml` para el otro formato: el paquete
 * contable necesita el archivo en memoria para subirlo a S3, no en la carpeta de
 * descargas del usuario.
 */

export type RenderedReportExcel = {
    fileName: string,
    bytes: Uint8Array
}

type RenderRouteToExcelOptions = {
    timeoutMs?: number
}

export function renderRouteToExcel(path: string, opts: RenderRouteToExcelOptions = {}): Promise<RenderedReportExcel> {
    const { timeoutMs = 20000 } = opts;

    return renderRouteInPortal<RenderedReportExcel>(
        path,
        ({ exportId, registerCleanup }) => new Promise<RenderedReportExcel>((resolve) => {
            const unsubscribe = ReportExcelExportedPubSub.subscribe((payload) => {
                if (payload.exportId !== exportId) return;
                unsubscribe();
                resolve({ fileName: payload.fileName, bytes: payload.bytes });
            });
            registerCleanup(() => unsubscribe());
        }),
        { timeoutMs }
    );
}
